import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import successImg from "../../assets/images/userprofile/successImg.png";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast, ToastContainer } from "react-toastify";
import CircularProgress from "@mui/material/CircularProgress";

import { useNavigate } from "react-router-dom";
import { axiosInstance_user } from "../../axiosInstance-user";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  bgcolor: "background.paper",
  border: "1px solid white",
  boxShadow: 24,
  pt: 2,
  px: 0,
  pb: 3,
};
const SUPPORTED_FORMATS = ["image/jpeg", "image/png", "application/pdf"];
const fileValidation = (fieldLabel) =>
  Yup.mixed()
    .required(`${fieldLabel} is required`)
    .test("fileFormat", "Only JPG/PNG/PDF allowed", (value) => {
      if (!value) return false;

      // Case 1: Fresh File object
      if (value instanceof File) {
        return SUPPORTED_FORMATS.includes(value.type);
      }

      // Case 2: Restored base64 string
      if (typeof value === "string") {
        return (
          value.startsWith("data:image/jpeg") ||
          value.startsWith("data:image/png") ||
          value.startsWith("data:application/pdf")
        );
      }

      return false;
    });

const documentSchema = Yup.object().shape({
  // payslip: Yup.mixed().required("Payslip is required"),
  // education_document: Yup.mixed().required("Educational document is required"),
  // passport: Yup.mixed().required("Passport is required"),
  // aadhar_or_pan: Yup.mixed().required("Aadhaar or PAN is required"),
  // pic_with_front_cam: Yup.mixed().required("Front cam pic is required"),

  // payslip: Yup.mixed()
  //   .required("Payslip is required")
  //   .test("fileFormat", "Only JPG/PNG/PDF allowed", (value) =>
  //     value ? SUPPORTED_FORMATS.includes(value.type) : false
  //   ),
  // education_document: Yup.mixed()
  //   .required("Educational document is required")
  //   .test("fileFormat", "Only JPG/PNG/PDF allowed", (value) =>
  //     value ? SUPPORTED_FORMATS.includes(value.type) : false
  //   ),
  // passport: Yup.mixed()
  //   .required("Passport is required")
  //   .test("fileFormat", "Only JPG/PNG/PDF allowed", (value) =>
  //     value ? SUPPORTED_FORMATS.includes(value.type) : false
  //   ),
  // aadhar_or_pan: Yup.mixed()
  //   .required("Aadhaar or PAN is required")
  //   .test("fileFormat", "Only JPG/PNG/PDF allowed", (value) =>
  //     value ? SUPPORTED_FORMATS.includes(value.type) : false
  //   ),
  // pic_with_front_cam: Yup.mixed()
  //   .required("Front cam pic is required")
  //   .test("fileFormat", "Only JPG/PNG/PDF allowed", (value) =>
  //     value ? SUPPORTED_FORMATS.includes(value.type) : false
  //   ),
  payslip: fileValidation("Payslip"),
  education_document: fileValidation("Educational document"),
  passport: fileValidation("Passport"),
  aadhar_or_pan: fileValidation("Aadhaar or PAN"),
  pic_with_front_cam: fileValidation("Front cam pic"),
  payslip_verified: Yup.string().required("Required"),

  education_document_verified: Yup.string().required("Required"),

  passport_verified: Yup.string().required("Required"),

  aadhar_or_pan_verified: Yup.string().required("Required"),

  pic_with_front_cam_verified: Yup.string().required("Required"),
});

export function DocumentInfo() {
  const navigate = useNavigate();
  const [fileNames, setFileNames] = useState({
    payslip: "Browse",
    education_document: "Browse",
    passport: "Browse",
    aadhar_or_pan: "Browse",
    pic_with_front_cam: "Browse",
  });
  const [previews, setPreviews] = useState({
    payslip: null,
    education_document: null,
    passport: null,
    aadhar_or_pan: null,
    pic_with_front_cam: null,
  });
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // const formik = useFormik({
  //   initialValues: {
  //     payslip: null,
  //     payslip_verified: "",
  //     education_document: null,
  //     education_document_verified: "",
  //     passport: null,
  //     passport_verified: "",
  //     aadhar_or_pan: null,
  //     aadhar_or_pan_verified: "",
  //     pic_with_front_cam: null,
  //     pic_with_front_cam_verified: "",
  //   },
  //   validationSchema: documentSchema,
  //   onSubmit: async (values) => {
  //     try {
  //       const dataToSave = {
  //         profile: {
  //           payslip: values.payslip,
  //           education_document: values.education_document,
  //           passport: values.passport,
  //           aadhar_or_pan: values.aadhar_or_pan,
  //           pic_with_front_cam: values.pic_with_front_cam,
  //           payslip_verified: Number(values.passport_verified),
  //           education_document_verified: Number(
  //             values.education_document_verified
  //           ),
  //           passport_verified: Number(values.passport_verified),
  //           aadhar_or_pan_verified: Number(values.aadhar_or_pan_verified),
  //           pic_with_front_cam_verified: Number(
  //             values.pic_with_front_cam_verified
  //           ),
  //         },
  //       };

  //       localStorage.setItem("documentDetails", JSON.stringify(dataToSave));
  //       handleOpen();
  //       setTimeout(() => {
  //         handleClose();
  //       }, 2000);
  //     } catch (error) {
  //       console.error("Error saving to localStorage:", error);
  //     }
  //   },
  // });
  // // Helper function of base 64
  // const convertToBase64 = (file) =>
  //   new Promise((resolve, reject) => {
  //     const reader = new FileReader();
  //     reader.readAsDataURL(file);
  //     reader.onload = () => resolve(reader.result);
  //     reader.onerror = (error) => reject(error);
  //   });
  // const handleFileChange = async (e, fieldName) => {
  //   const file = e.currentTarget.files[0];

  //   setFileNames((prev) => ({
  //     ...prev,
  //     [fieldName]: file ? file.name : "Browse",
  //   }));

  //   if (file) {
  //     const base64 = await convertToBase64(file);
  //     formik.setFieldValue(fieldName, base64); // store base64 in form state

  //     // preview only for images
  //     if (typeof base64 === "string" && base64.startsWith("data:image/")) {
  //       setPreviews((prev) => ({ ...prev, [fieldName]: base64 }));
  //     } else {
  //       setPreviews((prev) => ({ ...prev, [fieldName]: null }));
  //     }
  //   } else {
  //     formik.setFieldValue(fieldName, null);
  //     setPreviews((prev) => ({ ...prev, [fieldName]: null }));
  //   }
  // };
  const formik = useFormik({
    initialValues: {
      album:null,
      payslip: null,
      payslip_verified: "",
      education_document: null,
      education_document_verified: "",
      passport: null,
      passport_verified: "",
      aadhar_or_pan: null,
      aadhar_or_pan_verified: "",
      pic_with_front_cam: null,
      pic_with_front_cam_verified: "",
    },
    validationSchema: documentSchema,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        const dataToSave = {
          album:values.album,
          profile: {
            payslip: values.payslip,
            education_document: values.education_document,
            passport: values.passport,
            aadhar_or_pan: values.aadhar_or_pan,
            pic_with_front_cam: values.pic_with_front_cam,
            payslip_verified: Number(values.payslip_verified),

            education_document_verified: Number(
              values.education_document_verified
            ),
            passport_verified: Number(values.passport_verified),
            aadhar_or_pan_verified: Number(values.aadhar_or_pan_verified),
            pic_with_front_cam_verified: Number(
              values.pic_with_front_cam_verified
            ),
          },
        };

        localStorage.setItem("documentDetails", JSON.stringify(dataToSave));

        const basicDetails = JSON.parse(
          localStorage.getItem("basicDetails") || "{}"
        );
        const familyDetails = JSON.parse(
          localStorage.getItem("familyDetails") || "{}"
        );
        const educationDetails = JSON.parse(
          localStorage.getItem("educationDetails") || "{}"
        );
        const otherDetails = JSON.parse(
          localStorage.getItem("otherDetails") || "{}"
        );

        const allData = {
          ...basicDetails,
          ...familyDetails,
          ...educationDetails,
          ...otherDetails,
          ...dataToSave, // add this
          profile: {
            ...(basicDetails.profile || {}),

            ...(familyDetails.profile || {}),
            ...(educationDetails.profile || {}),
            ...(otherDetails.profile || {}),
            ...(dataToSave.profile || {}), // add this
          },
        };

        // // Build FormData
        // const formData = new FormData();

        // const appendFormData = (formData, data, parentKey = "") => {
        //   Object.entries(data).forEach(([key, value]) => {
        //     const formKey = parentKey ? `${parentKey}[${key}]` : key;

        //     if (Array.isArray(value)) {
        //       value.forEach((item) => {
        //         formData.append(`${formKey}[]`, item);
        //       });
        //     } else if (
        //       value !== null &&
        //       typeof value === "object" &&
        //       !(value instanceof Blob)
        //     ) {
        //       appendFormData(formData, value, formKey);
        //     } else if (value !== null && value !== undefined) {
        //       formData.append(formKey, value);
        //     }
        //   });
        // };

        // // ⬅️ Add this call before POST
        // appendFormData(formData, allData);
        // Build FormData
      const formData = new FormData();

      const appendFormData = (formData, data, parentKey = "") => {
        Object.entries(data).forEach(([key, value]) => {
          const formKey = parentKey ? `${parentKey}[${key}]` : key;

          // Stringify arrays for backend
          if (
            (key === "known_languages" || key === "lite_logins" || key === "social_media") &&
            Array.isArray(value)
          ) {
            formData.append(formKey, JSON.stringify(value));
          }
          // Nested objects
          else if (value && typeof value === "object" && !Array.isArray(value) && !(value instanceof File)) {
            appendFormData(formData, value, formKey);
          }
          // Other arrays (just in case)
          else if (Array.isArray(value)) {
            value.forEach((item) => formData.append(formKey, item));
          }
          // Files and normal values
          else if (value !== null && value !== undefined) {
            formData.append(formKey, value);
          }
        });
      };

      appendFormData(formData, allData);

        // Submit using multipart/form-data
        const response = await axiosInstance_user.post(
          "/users-profiles/",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (response.data?.status === "success") {
          setLoading(false); // Stop loader first
          handleOpen();
          setTimeout(() => {
            navigate("/user-profiles");
            localStorage.removeItem("basicDetails");
            localStorage.removeItem("familyDetails");
            localStorage.removeItem("educationDetails");
            localStorage.removeItem("otherDetails");
            localStorage.removeItem("documentDetails");
          }, 1500);
        } else if (response.data?.status === "error") {
          toast.error(
            response?.data?.message || "Please try again,Something went wrong!"
          );
          // toast.error("Please try again,Something went wrong! ");
        }
      } catch (error) {
        // catch (error) {
        //   setLoading(false);
        //   toast.error(error.response?.data?.message || "Please try again,Something went wrong!");
        //   // toast.error("Please try again,Something went wrong! ");
        //   // localStorage.removeItem("basicDetails");
        //   // localStorage.removeItem("familyDetails");
        //   // localStorage.removeItem("educationDetails");
        //   // localStorage.removeItem("otherDetails");
        //   // localStorage.removeItem("documentDetails");

        //   console.error("Error submitting profile:", error);
        //   // setTimeout(() => {
        //   //   // Force page reload
        //   //   window.location.reload();
        //   // }, 3000);
        // }
        console.error("Submission error:", error);
        if (error.response) {
          console.error("Response data:", error.response.data);
          console.error("Response status:", error.response.status);
          console.error("Response headers:", error.response.headers);
          const message = error.response.data?.message || "Submission failed.";
          toast.error(message);
          alert(`Error 400: ${JSON.stringify(error.response.data, null, 2)}`);
        } else if (error.request) {
          console.error(
            "Request made but no response received:",
            error.request
          );
          toast.error("No response from server.");
        } else {
          console.error("Error setting up request:", error.message);
          toast.error("Something went wrong.");
        }
      } finally {
        setLoading(false);
      }
    },
  });
  // const handleFileChange = (e, fieldName) => {
  //   const file = e.currentTarget.files[0];
  //   setFileNames((prev) => ({
  //     ...prev,
  //     [fieldName]: file ? file.name : "Browse",
  //   }));
  //   formik.setFieldValue(fieldName, file);
  // };
  const handleFileChange = (e, fieldName) => {
    const file = e.currentTarget.files[0];

    // set file name
    setFileNames((prev) => ({
      ...prev,
      [fieldName]: file ? file.name : "Browse",
    }));

    // set file into formik
    formik.setFieldValue(fieldName, file);

    // set preview (for image/pdf)
    if (file) {
      if (file.type === "application/pdf") {
        // PDF → create object URL to open in <a href="">
        const fileURL = URL.createObjectURL(file);
        setPreviews((prev) => ({
          ...prev,
          [fieldName]: fileURL,
        }));
      } else if (file.type.startsWith("image/")) {
        // Image → preview in <img>
        const reader = new FileReader();
        reader.onloadend = () => {
          setPreviews((prev) => ({
            ...prev,
            [fieldName]: reader.result,
          }));
        };
        reader.readAsDataURL(file);
      }
    } else {
      // Reset preview if no file selected
      setPreviews((prev) => ({
        ...prev,
        [fieldName]: "",
      }));
    }
  };

  // get and set form data from localStorage to fields
  useEffect(() => {
    const documentDetails = localStorage.getItem("documentDetails");
    if (documentDetails) {
      const parsed = JSON.parse(documentDetails);
      const prof = parsed.profile || {};

      // update fileNames to show uploaded state if base64 exists
      // setFileNames({
      //   payslip: prof.payslip ? "Uploaded" : "Browse",
      //   education_document: prof.education_document ? "Uploaded" : "Browse",
      //   passport: prof.passport ? "Uploaded" : "Browse",
      //   aadhar_or_pan: prof.aadhar_or_pan ? "Uploaded" : "Browse",
      //   pic_with_front_cam: prof.pic_with_front_cam ? "Uploaded" : "Browse",
      // });

      // preview only if the saved value is an image data URL (starts with data:image)
      // const isImage = (v) =>
      //   typeof v === "string" && v.startsWith("data:image/");

      // setPreviews({
      //   payslip: isImage(prof.payslip) ? prof.payslip : null,
      //   education_document: isImage(prof.education_document)
      //     ? prof.education_document
      //     : null,
      //   passport: isImage(prof.passport) ? prof.passport : null,
      //   aadhar_or_pan: isImage(prof.aadhar_or_pan) ? prof.aadhar_or_pan : null,
      //   pic_with_front_cam: isImage(prof.pic_with_front_cam)
      //     ? prof.pic_with_front_cam
      //     : null,
      // });

      formik.setValues({
        ...formik.initialValues,
        // payslip: prof.payslip || null,
        payslip_verified: prof.payslip_verified?.toString() || "",
        // education_document: prof.education_document || null,
        education_document_verified:
          prof.education_document_verified?.toString() || "",
        // passport: prof.passport || null,
        passport_verified: prof.passport_verified?.toString() || "",
        // aadhar_or_pan: prof.aadhar_or_pan || null,
        aadhar_or_pan_verified: prof.aadhar_or_pan_verified?.toString() || "",
        // pic_with_front_cam: prof.pic_with_front_cam || null,
        pic_with_front_cam_verified:
          prof.pic_with_front_cam_verified?.toString() || "",
      });
    }
  }, []);

  return (
    <form onSubmit={formik.handleSubmit}>
      {loading && (
        <div className="loader-overlay">
          <CircularProgress style={{ color: "#f24464" }} />
        </div>
      )}
      <div>
          {/* Row user image  */}
          <div className="doc-subcontainer">
          <div>
            <div className="doc-label">User Image</div>
            <div className="doc-input">
              <label htmlFor="albumInput" className="custom-file-label">
                {fileNames.album || "Browse"}
              </label>
              <input
                type="file"
                id="albumInput"
                className="custom-file-input"
                onChange={(e) => handleFileChange(e, "album")}
                accept="image/*"
              />
              {/* image preview */}
              {previews.album &&
                <img
                      src={previews.album}
                      alt="Preview"
                      className="image-preview mt-3"
                    />
               }
              {formik.touched.album && formik.errors.album && (
                <div className="text-danger">{formik.errors.album}</div>
              )}
            </div>
          </div>
          <div>
         {""}
          </div>
        </div>
        {/* Row 1: Payslip */}
        <div className="doc-subcontainer">
          <div>
            <div className="doc-label">
              Payslip <span className="text-danger">*</span>
            </div>
            <div className="doc-input">
              <label htmlFor="payInput" className="custom-file-label">
                {fileNames.payslip}
              </label>
              <input
                type="file"
                id="payInput"
                className="custom-file-input"
                onChange={(e) => handleFileChange(e, "payslip")}
                accept="image/*,application/pdf"
              />

              {/* image preview */}
              {previews.payslip &&
                // (
                //   <div style={{ marginTop: 8 }}>
                //     <img
                //       src={previews.payslip}
                //       alt="Payslip preview"
                //       style={{
                //         maxWidth: 150,
                //         maxHeight: 150,
                //         objectFit: "cover",
                //         borderRadius: 6,
                //       }}
                //     />
                //   </div>
                // )
                (previews.payslip.endsWith(".pdf") ? (
                  <a
                    href={previews.payslip}
                    target="_blank"
                    rel="noreferrer"
                    className="mt-3"
                  >
                    View PDF
                  </a>
                ) : (
                  <a href={previews.payslip} target="_blank" rel="noreferrer">
                    <img
                      src={previews.payslip}
                      alt="Preview"
                      className="image-preview mt-3"
                    />
                  </a>
                ))}
              {formik.touched.payslip && formik.errors.payslip && (
                <div className="text-danger">{formik.errors.payslip}</div>
              )}
            </div>
          </div>
          <div>
            <div className="doc-label">
              Payslip Verified <span className="text-danger">*</span>
            </div>
            <select
              className="dropdown-btnDoc"
              name="payslip_verified"
              value={formik.values.payslip_verified}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            >
              <option value="" disabled selected>
                Select
              </option>
              <option value="2">Pending</option>
              <option value="3">Verified</option>
              <option value="4">Verification Failed</option>
            </select>
            {formik.touched.payslip_verified &&
              formik.errors.payslip_verified && (
                <div className="text-danger">
                  {formik.errors.payslip_verified}
                </div>
              )}
          </div>
        </div>

        {/* Row 2: Education */}
        <div className="doc-subcontainer">
          <div>
            <div className="doc-label">
              Educational Documents <span className="text-danger">*</span>
            </div>
            <div className="doc-input">
              <label htmlFor="eduInput" className="custom-file-label">
                {fileNames.education_document}
              </label>
              <input
                type="file"
                id="eduInput"
                className="custom-file-input"
                onChange={(e) => handleFileChange(e, "education_document")}
                accept="image/*,application/pdf"
              />

              {/* image preview */}
              {previews.education_document &&
                // (
                //   <div style={{ marginTop: 8 }}>
                //     <img
                //       src={previews.education_document}
                //       alt="Education doc preview"
                //       style={{
                //         maxWidth: 150,
                //         maxHeight: 150,
                //         objectFit: "cover",
                //         borderRadius: 6,
                //       }}
                //     />
                //   </div>
                // )
                (previews.education_document.endsWith(".pdf") ? (
                  <a
                    href={previews.education_document}
                    target="_blank"
                    rel="noreferrer"
                    className="mt-3"
                  >
                    View PDF
                  </a>
                ) : (
                  <a
                    href={previews.education_document}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src={previews.education_document}
                      alt="Preview"
                      className="image-preview mt-3"
                    />
                  </a>
                ))}
              {formik.touched.education_document &&
                formik.errors.education_document && (
                  <div className="text-danger">
                    {formik.errors.education_document}
                  </div>
                )}
            </div>
          </div>
          <div>
            <div className="doc-label">
              Educational Documents Verified{" "}
              <span className="text-danger">*</span>
            </div>
            <select
              className="dropdown-btnDoc"
              name="education_document_verified"
              value={formik.values.education_document_verified}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            >
              <option value="" disabled selected>
                Select
              </option>
              <option value="2">Pending</option>
              <option value="3">Verified</option>
              <option value="4">Verification Failed</option>
            </select>
            {formik.touched.education_document_verified &&
              formik.errors.education_document_verified && (
                <div className="text-danger">
                  {formik.errors.education_document_verified}
                </div>
              )}
          </div>
        </div>

        {/* Row 3: Passport */}
        <div className="doc-subcontainer">
          <div>
            <div className="doc-label">
              Passport <span className="text-danger">*</span>
            </div>
            <div className="doc-input">
              <label htmlFor="passportInput" className="custom-file-label">
                {fileNames.passport}
              </label>
              <input
                type="file"
                id="passportInput"
                className="custom-file-input"
                onChange={(e) => handleFileChange(e, "passport")}
                accept="image/*,application/pdf"
              />

              {/* image preview */}
              {previews.passport &&
                // (
                //   <div style={{ marginTop: 8 }}>
                //     <img
                //       src={previews.passport}
                //       alt="Passport preview"
                //       style={{
                //         maxWidth: 150,
                //         maxHeight: 150,
                //         objectFit: "cover",
                //         borderRadius: 6,
                //       }}
                //     />
                //   </div>
                // )
                (previews.passport.endsWith(".pdf") ? (
                  <a
                    href={previews.passport}
                    target="_blank"
                    rel="noreferrer"
                    className="mt-3"
                  >
                    View PDF
                  </a>
                ) : (
                  <a href={previews.passport} target="_blank" rel="noreferrer">
                    <img
                      src={previews.education_document}
                      alt="Preview"
                      className="image-preview mt-3"
                    />
                  </a>
                ))}
              {formik.touched.passport && formik.errors.passport && (
                <div className="text-danger">{formik.errors.passport}</div>
              )}
            </div>
          </div>
          <div>
            <div className="doc-label">
              Passport Verified <span className="text-danger">*</span>
            </div>
            <select
              className="dropdown-btnDoc"
              name="passport_verified"
              value={formik.values.passport_verified}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            >
              <option value="" disabled selected>
                Select
              </option>
              <option value="2">Pending</option>
              <option value="3">Verified</option>
              <option value="4">Verification Failed</option>
            </select>
            {formik.touched.passport_verified &&
              formik.errors.passport_verified && (
                <div className="text-danger">
                  {formik.errors.passport_verified}
                </div>
              )}
          </div>
        </div>

        {/* Row 4: Aadhar/PAN */}
        <div className="doc-subcontainer">
          <div>
            <div className="doc-label">
              Aadhaar or PAN <span className="text-danger">*</span>
            </div>
            <div className="doc-input">
              <label htmlFor="aadharInput" className="custom-file-label">
                {fileNames.aadhar_or_pan}
              </label>
              <input
                type="file"
                id="aadharInput"
                className="custom-file-input"
                onChange={(e) => handleFileChange(e, "aadhar_or_pan")}
                accept="image/*,application/pdf"
              />

              {/* image preview */}
              {previews.aadhar_or_pan &&
                // (
                //   <div style={{ marginTop: 8 }}>
                //     <img
                //       src={previews.aadhar_or_pan}
                //       alt="Aadhar preview"
                //       style={{
                //         maxWidth: 150,
                //         maxHeight: 150,
                //         objectFit: "cover",
                //         borderRadius: 6,
                //       }}
                //     />
                //   </div>
                // )
                (previews.aadhar_or_pan.endsWith(".pdf") ? (
                  <a
                    href={previews.aadhar_or_pan}
                    target="_blank"
                    rel="noreferrer"
                    className="mt-3"
                  >
                    View PDF
                  </a>
                ) : (
                  <a
                    href={previews.aadhar_or_pan}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src={previews.aadhar_or_pan}
                      alt="Preview"
                      className="image-preview mt-3"
                    />
                  </a>
                ))}
              {formik.touched.aadhar_or_pan && formik.errors.aadhar_or_pan && (
                <div className="text-danger">{formik.errors.aadhar_or_pan}</div>
              )}
            </div>
          </div>
          <div>
            <div className="doc-label">
              Aadhaar or PAN Verified <span className="text-danger">*</span>
            </div>
            <select
              className="dropdown-btnDoc"
              name="aadhar_or_pan_verified"
              value={formik.values.aadhar_or_pan_verified}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            >
              <option value="" disabled selected>
                Select
              </option>
              <option value="2">Pending</option>
              <option value="3">Verified</option>
              <option value="4">Verification Failed</option>
            </select>
            {formik.touched.aadhar_or_pan_verified &&
              formik.errors.aadhar_or_pan_verified && (
                <div className="text-danger">
                  {formik.errors.aadhar_or_pan_verified}
                </div>
              )}
          </div>
        </div>

        {/* Row 5: Pic with front cam */}
        <div className="doc-subcontainer">
          <div>
            <div className="doc-label">
              Pic with Front Cam <span className="text-danger">*</span>
            </div>
            <div className="doc-input">
              <label htmlFor="frontCamInput" className="custom-file-label">
                {fileNames.pic_with_front_cam}
              </label>
              <input
                type="file"
                id="frontCamInput"
                className="custom-file-input"
                accept="image/*,application/pdf"
                onChange={(e) => handleFileChange(e, "pic_with_front_cam")}
              />

              {/* image preview */}
              {previews.pic_with_front_cam &&
                //  (
                //   <div style={{ marginTop: 8 }}>
                //     <img
                //       src={previews.pic_with_front_cam}
                //       alt="Payslip preview"
                //       style={{
                //         maxWidth: 150,
                //         maxHeight: 150,
                //         objectFit: "cover",
                //         borderRadius: 6,
                //       }}
                //     />
                //   </div>
                // )
                (previews.pic_with_front_cam.endsWith(".pdf") ? (
                  <a
                    href={previews.pic_with_front_cam}
                    target="_blank"
                    rel="noreferrer"
                    className="mt-3"
                  >
                    View PDF
                  </a>
                ) : (
                  <a
                    href={previews.pic_with_front_cam}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src={previews.pic_with_front_cam}
                      alt="Preview"
                      className="image-preview mt-3"
                    />
                  </a>
                ))}

              {formik.touched.pic_with_front_cam &&
                formik.errors.pic_with_front_cam && (
                  <div className="text-danger">
                    {formik.errors.pic_with_front_cam}
                  </div>
                )}
            </div>
          </div>
          <div>
            <div className="doc-label">
              Pic with Front Cam Verified <span className="text-danger">*</span>
            </div>
            <select
              className="dropdown-btnDoc"
              name="pic_with_front_cam_verified"
              value={formik.values.pic_with_front_cam_verified}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            >
              <option value="" disabled selected>
                Select
              </option>
              <option value="2">Pending</option>
              <option value="3">Verified</option>
              <option value="4">Verification Failed</option>
            </select>
            {formik.touched.pic_with_front_cam_verified &&
              formik.errors.pic_with_front_cam_verified && (
                <div className="text-danger">
                  {formik.errors.pic_with_front_cam_verified}
                </div>
              )}
          </div>
        </div>

        {/* Submit Button & Modal */}
        <div className="btnBasicSave">
          <Button type="submit">Submit</Button>
        </div>
        <Modal
          open={open}
          onClose={handleClose}
          closeAfterTransition
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
        >
          <Fade in={open}>
            <Box sx={style} className="modal-box">
              <img src={successImg} alt="Success" />
              <Typography
                id="transition-modal-title"
                variant="h6"
                component="h2"
              >
                Thank You
              </Typography>
              <Typography id="transition-modal-description" sx={{ mt: 2 }}>
                The profile has been added successfully
              </Typography>
            </Box>
          </Fade>
        </Modal>
      </div>
    </form>
  );
}
